import { AppConfigContext } from '@App/AppConfigContext';
import { useVideoConsultationStore } from '@App/stores';
import { Features } from '@Config/Features';
import { path, Routes } from '@Config/Routes';
import { InsuranceType } from '@Framework/constants/InsuranceType';
import { Box } from '@material-ui/core';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import Feature from '../../../atoms/Feature';
import { OdsLayout } from '../../../layouts/odsLayout';
import { BenefitBox } from '../../../molecules/BenefitBox/BenefitBox';
import { PrimaryAlert } from '../../../molecules/PrimaryAlert';
import { RadioSelect } from '../../../molecules/RadioSelect/RadioSelect';
import { ListBox } from '../../../organisms/ListBox/ListBox';
import { VideoConsultationSelectionPageData } from './constants';

const { benefits, faqs } = VideoConsultationSelectionPageData;

const SelectionPage = (): React.ReactElement => {
  const navigate = useNavigate();
  const { features } = useContext(AppConfigContext);

  const { insuranceType, setInsuranceType } = useVideoConsultationStore(({ insuranceType, setInsuranceType }) => ({
    insuranceType,
    setInsuranceType
  }));

  //Preselection public insurance
  if (insuranceType === undefined) {
    setInsuranceType(InsuranceType.PUBLIC);
  }

  const child: React.ReactElement = (
    <>
      <Feature featureName={Features.hideVideoJourney}>
        <Box pb={2.5}>
          <PrimaryAlert text="Momentan ist dieser Service nicht verfügbar." />
        </Box>
      </Feature>

      <RadioSelect
        labelPrivate={'Ich bin privat versichert'}
        labelPublic={'Ich bin gesetzlich versichert'}
        title="Wie sind Sie versichert?"
        disableJourney={features['wsssh-1561']}
        label="Weiter"
        value={insuranceType}
        onButtonClick={() => navigate(path(`${Routes.VIDEO_CONSULTATION}/${insuranceType}`))}
        onChange={insuranceType => setInsuranceType(insuranceType)}
      />
    </>
  );

  const child2: React.ReactElement = (
    <>
      <Box pb={3.7}>
        <BenefitBox elements={benefits[insuranceType || InsuranceType.PUBLIC]} />
      </Box>
      <ListBox
        title="Benötigen Sie Hilfe?"
        subtitle="So funktioniert's"
        elements={faqs[insuranceType || InsuranceType.PUBLIC]}
      />
    </>
  );

  return <OdsLayout children1={child} children2={child2} />;
};

export { SelectionPage };
